import { Link } from "react-router-dom";
import { ShieldCheck, Mail, Send } from "lucide-react";
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const columns = [
  {
    title: "Services",
    links: [
      { to: "/services", label: "Website Design" },
      { to: "/services", label: "Web Hosting" },
      { to: "/services", label: "SSL Certificates" },
      { to: "/services", label: "Domain Registration" },
      { to: "/services", label: "Website Security" },
      { to: "/services", label: "Technical Support" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/portfolio", label: "Portfolio" },
      { to: "/pricing", label: "Pricing" },
      { to: "/blog", label: "Blog" },
      { to: "/faq", label: "FAQ" },
      { to: "/contact", label: "Contact" },
      { to: "/quote", label: "Request Quote" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms & Conditions" },
      { to: "/refund", label: "Refund Policy" },
      { to: "/cookies", label: "Cookie Policy" },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Subscribed. Thanks for joining.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="mt-24 border-t border-black/5 dark:border-white/10 bg-white dark:bg-[#0B1220]" data-testid="site-footer">
      <div className="container-page py-14 grid gap-10 md:grid-cols-6">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2 font-semibold">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-[#1565FF] to-[#4FC3F7] text-white">
              <ShieldCheck className="h-4 w-4" strokeWidth={2.5} />
            </span>
            <span>Tech Alpha <span className="text-[#1565FF]">SSL</span></span>
          </Link>
          <p className="mt-3 text-sm text-muted-foreground max-w-xs">
            Enterprise SSL, security and hosting for modern businesses. Built for speed, trust and scale.
          </p>
          <div className="mt-4 flex items-center gap-2 text-sm text-muted-foreground">
            <Mail className="h-4 w-4" />
            <a href="mailto:techalphassl@gmail.com" className="hover:text-[#1565FF]">techalphassl@gmail.com</a>
          </div>

          <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-sm">
            <input
              type="email"
              required
              placeholder="Email for updates"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="footer-newsletter-email"
              className="flex-1 rounded-full border border-black/10 dark:border-white/10 bg-white dark:bg-white/5 px-4 py-2 text-sm outline-none focus:border-[#1565FF]"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="footer-newsletter-submit"
              className="btn-primary !py-2 !px-4 !text-sm"
            >
              <Send className="h-3.5 w-3.5" /> {loading ? "..." : "Join"}
            </button>
          </form>
        </div>

        {columns.map((c) => (
          <div key={c.title}>
            <h4 className="text-sm font-semibold tracking-tight">{c.title}</h4>
            <ul className="mt-3 space-y-2">
              {c.links.map((l, i) => (
                <li key={i}>
                  <Link to={l.to} className="text-sm text-muted-foreground hover:text-[#1565FF] transition">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h4 className="text-sm font-semibold tracking-tight">Portals</h4>
          <ul className="mt-3 space-y-2">
            <li><Link to="/portal/login" className="text-sm text-muted-foreground hover:text-[#1565FF]" data-testid="footer-portal-login">Client Portal</Link></li>
            <li><Link to="/portal/signup" className="text-sm text-muted-foreground hover:text-[#1565FF]" data-testid="footer-portal-signup">Create Account</Link></li>
            <li><Link to="/admin/login" className="text-sm text-muted-foreground hover:text-[#1565FF]" data-testid="footer-admin-login">Admin Login</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-black/5 dark:border-white/10 py-6">
        <div className="container-page flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Tech Alpha SSL. All rights reserved.</p>
          <p>techalphassl.com</p>
        </div>
      </div>
    </footer>
  );
}
